<template>
  <div class="relative overflow-hidden rounded-full">
    <input
      :value="modelValue"
      type="search"
      enterkeyhint="search"
      :class="[
        'block w-full rounded-full border border-background-fg/8 bg-background pl-6 pr-16 text-left text-sm font-semibold focus:outline-none sm:text-sm',
        'focus:border-primary focus:ring-primary',
      ]"
      placeholder="Search"
      @input="onInput"
    />
    <div
      class="absolute inset-y-0 right-0 flex w-14 items-center justify-center border-l border-background-fg/8 bg-background-fg/3"
    >
      <IconHeroiconsMagnifyingGlass />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string | undefined
}>()
const emit = defineEmits<{
  (
    event: "update:modelValue",
    value: typeof props.modelValue
  ): void
}>()

const onInput = (event: Event) => {
  const value_ = (event.target as HTMLInputElement)?.value
  emit("update:modelValue", value_)
}
</script>
